/*
 * Public API Surface of split-button
 */

export * from './lib/split-button.types';
export * from './lib/split-button.component';
export * from './lib/split-button.module';
